import React from 'react';
import { useEventRegistrationCountDown } from '../../hooks/useCountDown';
import {
  EVENT_MESSAGE,
  EVENT_REGISTRATION_STATUS,
  EVENT_RESULT_TYPE,
} from '../../utils/eventHelpers';
import EventBar from './EventBar';
import EventCountDown from './EventCountDown';
import EventMsgBar from './EventMsgBar';

const EventBarWrapper = ({
  result,
  resultWithRealm,
  resultStatus,
  onClick,
  countDownType = '',
}) => {
  const { statusRegistration, hours, minutes, days } =
    useEventRegistrationCountDown();

  if (result !== '' && resultStatus === EVENT_RESULT_TYPE.SUCCESS) {
    return (
      <EventMsgBar
        type="success"
        message={EVENT_MESSAGE.REGISTERED}
        onClick={onClick}
      />
    );
  }
  if (result !== '' && resultStatus === EVENT_RESULT_TYPE.ERROR) {
    return (
      <EventMsgBar
        type="error"
        message={EVENT_MESSAGE.NOT_FOUND}
        onClick={onClick}
      />
    );
  }
  if (resultWithRealm !== '' && resultStatus === EVENT_RESULT_TYPE.SUCCESS) {
    return (
      <EventMsgBar
        type="success"
        message={EVENT_MESSAGE.REGISTERED_WITH_REAML}
        reamls={1}
        onClick={onClick}
        // txnHash="0x24b79999990x24b79e58"
      />
    );
  }

  if (statusRegistration === EVENT_REGISTRATION_STATUS.IN_PROCESS) {
    return (
      <EventBar
        title="Registration closes in"
        subtitle={
          <EventCountDown
            hours={hours}
            minutes={minutes}
            days={days}
            type={countDownType}
          />
        }
      />
    );
  }

  return (
    <EventBar
      className="event-bar-not-started"
      title="Registration:"
      subtitle={
        <>
          <span className="date">13 Apr</span> 12:00 -{' '}
          <span className="date">17 Apr</span> 02:00 EST
        </>
      }
    />
  );
};

export default EventBarWrapper;
